import {
  AllStateUrl,
  AllCityUrl,
  CompanyUrl,
  GetUserFiles,
  OnboardingAddDealerCompanyUrl,
  GetDealerCompaniesUrl,
  DealerCompanyUrl,
  RemoveDealerCompaniesUrl,
  benifitCheckWithPincodeUrl,
  getDealerUsersListUrl,
  RemoveEmployeeOnboardedUrl,
  getBrandUrl,
  getAllIndustryProductUrl,
  GstUserDataFetchUrl,
  GstUserGstDataFetchUrl,
  GstUserPanDataFetchUrl,
  totalSaleTotalBuyUrl,
  GetProductUrl,
  GetSubProductUrl,
  GetProductPricesUrl,
  DealerCompanyBaseProductPriceUrl,
  createOrderBookingUrl,
  getOrderBookingPaginatedUrl,
  addRolePermissionUrl,
  updateBookingOrderStatusByCompanyAdminUrl,
  updateOrderStatusByCompanyAdminUrl,
  GetOrderBookingLimitUrl,
  GstIndustriesUrl,
  GetDealerShipCompaniesWithIndustriesidUrl,
  getDitributorsWithCementCoIdForRetailerUrl,
  getDitributorsWithCementCoIdForAssociateUrl,
  CreateSecondaryOrderUrl,
  GetSecondaryOrdersRetailerUrl,
  GetSecondaryOrdersUrl,
  SellDistributorUpdateApprovalStatusUrl,
  SellDistributorInventoryUrl,
  SellDistributorViaPOUrl,
  checkForInventoryForSellInSecondaryOrderActionUrl,
  getSkuDetailsUrl,
  DealerCompanyBaseProductUrl,
  editOrderBookingUrl,
  deleteOrderBookingUrl,
  GetActiveCompaniesByDistrictUrl,
  GetDistributorSecondaryOrderShowActionTriggerButtonUrl,
} from '../api';

import { axios } from '../../../utils/settings';
import { getToken, getTokenHeader } from './index';

import { Buffer } from 'buffer';

export const GetAllStates = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    let params = { params: {} };
    if (token) {
      params = { params: {}, ...getTokenHeader(token) };
    } else {
      params = { params: {} };
    }
    await axios
      .get(AllStateUrl(), params)
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};

export const GetAllCityOfState = async (stateId) => {
  return new Promise(async (next) => {
    let token = await getToken();
    let params = { params: {} };
    if (token) {
      params = { params: {}, ...getTokenHeader(token) };
    } else {
      params = { params: {} };
    }

    await axios
      .get(`${AllCityUrl()}/${stateId}`, params)
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        next({ error: error });
      });
  });
};

export const GetAllCompanies = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${CompanyUrl()}`, data, getTokenHeader(token))
      .then(async ({ data: x }) => {
        //
        return next(x);
      })
      .catch(function (error) {
        //
        return next({ error: error });
      });
  });
};

export const GetActiveCompaniesByDistrict = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetActiveCompaniesByDistrictUrl()}`, getTokenHeader(token))
      .then(async ({ data: x }) => {
        //
        return next(x);
      })
      .catch(function (error) {
        //
        return next({ error: error });
      });
  });
};

export const GetDealerCompanies = async () => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${DealerCompanyUrl()}`, { params: {}, ...getTokenHeader(token) })
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};
export const getDitributorsWithCementCoIdForRetailer = async (
  manufacturer_id,
) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${getDitributorsWithCementCoIdForRetailerUrl()}`, {
        params: { manufacturer_id: manufacturer_id },
        ...getTokenHeader(token),
      })
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};
export const getDitributorsWithCementCoIdForAssociate = async (
  manufacturer_id,
) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${getDitributorsWithCementCoIdForAssociateUrl()}`, {
        params: { manufacturer_id: manufacturer_id },
        ...getTokenHeader(token),
      })
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};

export const getOrderBookingPaginatedAction = (
  fString,
  pageNumber,
  monthFilter,
  selectedDealershipCompany,
  ffString,
) => {
  return new Promise(async (next) => {
    let token = await getToken();
    let url;

    if (monthFilter?.start && monthFilter?.end && selectedDealershipCompany) {
      url = `${getOrderBookingPaginatedUrl()}?f=id$gte$0&f=${fString}&f=seller_id$eq$${selectedDealershipCompany}&f=created_at$gte$${
        monthFilter.start
      }&f=created_at$lte$${
        monthFilter.end
      }&o=created_at$desc&page=${pageNumber}&page_size=10`;
      if (ffString) {
        url = url + `&f=${ffString}`;
      }
    } else if (monthFilter?.start && monthFilter?.end) {
      url = `${getOrderBookingPaginatedUrl()}?f=id$gte$0&f=${fString}&f=created_at$gte$${
        monthFilter.start
      }&f=created_at$lte$${
        monthFilter.end
      }&o=created_at$desc&page=${pageNumber}&page_size=10`;
      if (ffString) {
        url = url + `&f=${ffString}`;
      }
    } else if (selectedDealershipCompany) {
      url = `${getOrderBookingPaginatedUrl()}?f=id$gte$0&f=${fString}&f=seller_id$eq$${selectedDealershipCompany}&o=created_at$desc&page=${pageNumber}&page_size=10`;
      if (ffString) {
        url = url + `&f=${ffString}`;
      }
    } else {
      url = `${getOrderBookingPaginatedUrl()}?f=id$gte$0&f=${fString}&o=created_at$desc&page=${pageNumber}&page_size=10`;
      if (ffString) {
        url = url + `&f=${ffString}`;
      }
    }

    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updateOrderStatusByCompanyAdminAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${updateOrderStatusByCompanyAdminUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const editOrderBookingAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${editOrderBookingUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const deleteOrderBookingAction = async (id) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${deleteOrderBookingUrl()}?order_booking_id=${id}`,
        null,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updateBookingOrderStatusByCompanyAdminAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${updateBookingOrderStatusByCompanyAdminUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const GetDealerCompaniesBaseProductPrice = async (id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${DealerCompanyBaseProductPriceUrl()}?company_id=${id}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};
export const CompaniesBaseProductPrice = async (id,useresiId) => {
  return new Promise(async next => {
    let token = await getToken();
    await axios
      .get(`${DealerCompanyBaseProductPriceUrl()}?company_id=${id}&user_esi_id=${useresiId}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({data: x}) => {
        return next(x);
      })
      .catch(function (error) {
        return next({error: error});
      });
  });
};
export const GetDealerCompaniesBaseProduct = async (id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${DealerCompanyBaseProductUrl()}?base_product_company_id=${id}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};
export const createOrderBookingAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${createOrderBookingUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetUserFilesNow = async (userId, fileType) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const imageUrl = `${GetUserFiles()}/${userId}/${fileType}`;
    await axios
      .get(imageUrl, {
        ...getTokenHeader(token),
        responseType: 'arraybuffer',
      })
      .then((response) => {
        let data = `data:${
          response.headers['content-type']
        };base64,${Buffer.from(response.data, 'binary').toString('base64')}`;
        return next(data);
        // return next(response.config.url)
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};

export const OnboardingAddDealerCompanyNow = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(OnboardingAddDealerCompanyUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const GetDealerCompaniesNow = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(GetDealerCompaniesUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const GetSubProducts = async (str) => {
  return new Promise(async (next) => {
    const token = await getToken();
    let axiosUrl = GetProductUrl();
    if (str) {
      axiosUrl = `${GetSubProductUrl()}?company_id=${str}`;
    }
    await axios
      .get(axiosUrl, { ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const GetProductPrices = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${GetProductPricesUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const RemoveDealerCompaniesNow = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${RemoveDealerCompaniesUrl()}/${data.cement_co_id}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const RemoveEmployeeOnboarded = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .delete(
        `${RemoveEmployeeOnboardedUrl()}?company_user_id=${
          data.company_user_id
        }`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const benifitCheckWithPincode = async (pincode) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(
        `${benifitCheckWithPincodeUrl()}?pincode=${pincode}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        //
        return err;
      });
  });
};
export const getDealerUsersList = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getDealerUsersListUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const addRolePermissionAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${addRolePermissionUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const GetAllBrands = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${getBrandUrl()}`, data, getTokenHeader(token))
      .then(async ({ data: x }) => {
        //
        return next(x);
      })
      .catch(function (error) {
        //
        return next({ error: error });
      });
  });
};
export const GetAllIndustryProducts = async (id, data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${getAllIndustryProductUrl()}?product_type=${id}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data: x }) => {
        //
        return next(x);
      })
      .catch(function (error) {
        //
        return next({ error: error });
      });
  });
};

// onboading Gst fetch for details
export const GstUserGstDataFetch = async (gst) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${GstUserGstDataFetchUrl()}?gstin=${gst}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        //
        return err;
      });
  });
};

// onboading Gst fetch for details
export const GstUserPanDataFetch = async (pan, checkExists = true) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${GstUserPanDataFetchUrl()}?pan_no=${pan}&check_exists=${checkExists}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getTotalSaleTotalBuy = async () => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${totalSaleTotalBuyUrl()}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({ data: x }) => {
        //
        return next(x);
      })
      .catch(function (error) {
        //
        return next({ error: error });
      });
  });
};

export const GetOrderBookingLimit = async (params) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${GetOrderBookingLimitUrl()}`, {
        params: params ? params : {},
        ...getTokenHeader(token),
      })
      .then(async ({ data: x }) => {
        //
        return next(x);
      })
      .catch(function (error) {
        //
        return next({ error: error });
      });
  });
};

// Get industries
// onboading Gst fetch for details
export const GstIndustries = async (gst) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${GstIndustriesUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

// get dealership companies with industry id
export const GstDealerShipCompanyWithIndustryId = async (industryId) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(
        `${GetDealerShipCompaniesWithIndustriesidUrl()}?industry_type=${industryId}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

// Create Secondary Order
export const CreateSecondaryOrder = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${CreateSecondaryOrderUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

// Get Secondary Orders for retailer
export const GetSecondaryOrdersRetailerAction = (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetSecondaryOrdersRetailerUrl()}`, {
        params: params ? params : {},
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// Get Secondary Orders
export const GetSecondaryOrdersAction = (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetSecondaryOrdersUrl()}`, {
        params: params ? params : {},
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const SellDistributorUpdateApprovalStatusAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${SellDistributorUpdateApprovalStatusUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const SellDistributorInventoryAction = async (id) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${SellDistributorInventoryUrl()}?secondary_order_id=${id}`,
        {},
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getDistributorSecondaryOrderShowActionTriggerButtonAction = async (
  id,
) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(
        `${GetDistributorSecondaryOrderShowActionTriggerButtonUrl()}?secondary_order_id=${id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const SellDistributorViaPOAction = async ({
  secondary_order_id,
  order_booking_id,
}) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${SellDistributorViaPOUrl()}?secondary_order_id=${secondary_order_id}&order_booking_id=${order_booking_id}`,
        {},
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const checkForInventoryForSellInSecondaryOrderAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${checkForInventoryForSellInSecondaryOrderActionUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getSkuDetails = async (companyid, data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${getSkuDetailsUrl()}?company_id=${companyid}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
